// MUI
import { CircularProgress, Stack } from '@mui/material'

// Components
import Header from 'components/molecules/Header/Header'
import LocationHierarchy from './locations-hierarchy/LocationHierarchy'
import Select from 'components/molecules/Select/Select'

// Style
import './Receive.scss'

// Router
import { SCAN } from 'app/ROUTES_CONSTANTS'

// Logic
import { useLogic } from './Receive.logic'
import { ReceivingProvider } from './receiveContext'

const ReceiveContent = () => {
  const { navigate, locations, rawLocations, isLoading } = useLogic()

  return (
    <div className="receiving-container">
      <Header title="Select Location" parent="Receiving" />
      <Stack padding={2.5} gap={2.5}>
        <Select
          hasSearchIcon
          options={locations}
          onSelect={(item) => navigate(SCAN(String(item.id)))}
          label="Search locations"
        />
        {isLoading && (
          <div className="loading">
            <CircularProgress />
          </div>
        )}
        {!isLoading && rawLocations && (
          <div className="list">
            <LocationHierarchy
              locations={rawLocations}
              onSelect={(item) => navigate(SCAN(String(item.id)))}
            />
          </div>
        )}
      </Stack>
    </div>
  )
}

const Receive = () => {
  return (
    <ReceivingProvider>
      <ReceiveContent />
    </ReceivingProvider>
  )
}

export default Receive
